import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Quote } from "lucide-react";

export default function Stories() {
  const [stories, setStories] = useState([]);
  useEffect(() => {
    api.get("/success-stories").then((r) => setStories(r.data.stories || [])).catch(() => {});
  }, []);

  return (
    <div data-testid="stories-page">
      <section className="section">
        <div className="container-editorial">
          <div className="eyebrow">Success stories</div>
          <h1 className="mt-4 font-serif text-5xl leading-[1.05] text-ink md:text-6xl">
            The keys that <em className="not-italic text-clay">unlocked</em>.
          </h1>
          <p className="mt-6 max-w-2xl text-lg leading-relaxed text-ink-muted">
            Restoration is rarely loud. It looks like a returned key, a rebuilt table, a first honest conversation.
            These are stories from our community, shared with permission.
          </p>

          <div className="mt-14 grid grid-cols-1 gap-8 md:grid-cols-2">
            {stories.map((s, i) => (
              <article
                key={s.id}
                data-testid={s.id}
                className={`overflow-hidden rounded-3xl border border-clay/15 bg-white ${i === 0 ? "md:col-span-2" : ""}`}
              >
                <div className={`grid grid-cols-1 ${i === 0 ? "md:grid-cols-2" : ""}`}>
                  <div className={`${i === 0 ? "" : "aspect-[16/10]"} overflow-hidden`}>
                    <img src={s.image} alt={s.headline} className="h-full w-full object-cover" />
                  </div>
                  <div className="p-8 md:p-10">
                    <Quote className="h-6 w-6 text-clay" />
                    <div className="mt-4 text-xs font-bold uppercase tracking-[0.22em] text-sage">{s.program}</div>
                    <h3 className="mt-2 font-serif text-3xl leading-tight text-ink">{s.headline}</h3>
                    <p className="mt-4 leading-relaxed text-ink-muted">{s.excerpt}</p>
                    <div className="mt-6 font-serif text-lg italic text-clay">— {s.name}</div>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
